import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {Query} from 'react-apollo';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';

import {HeadlineH1, NewButton, EntityTable, LoadingIndicator} from 'arkulpa-fec';
import {FlatButton} from 'material-ui';
import {StatusSelectionRow} from './Users';
import {translateStatus, DEVICE_IN_USE, DEVICE_NEW} from '../constants/deviceConstants';
import {ROLE_THOMASHILFEN} from '../constants/userConstants';

const GET_ALL_DEVICES = gql`
  query allDevices($status: String!) {
    allDevices(status: $status) {
      _id
      deviceId
      deviceNr
      token
      isTH
    }
  }
`;

const _tableConfig = (maxRows, role) => {
  const cols = [
    {
      header: 'Device Id',
      valueKey: 'deviceId',
      method: (deviceId) => deviceId,
      width: '25%',
    },
    {
      header: 'Device Nr',
      valueKey: 'deviceNr',
      method: (deviceNr) => deviceNr,
      width: '25%',
    },
    {
      header: 'token',
      valueKey: 'token',
      method: (token) => token,
      width: '40%',
    },
  ];
  if (role !== ROLE_THOMASHILFEN) {
    cols.push({
      header: 'Thomashilfen',
      valueKey: 'isTH',
      method: (isTH) => (isTH ? 'Ja' : 'Nein'),
      width: '10%',
    });
  }
  return {
    maxRows,
    cols,
  };
};

const RefetchButton = ({status, refetch}) => (
  <FlatButton onClick={() => refetch({status})} label={`${translateStatus(status)}`} />
);

const Devices = ({maxRows, history, user: {role}}) => (
  <Query query={GET_ALL_DEVICES} variables={{status: DEVICE_IN_USE}} cachePolicy='network-only'>
    {({loading, error, data: {allDevices}, refetch}) => {
      if (loading) return <LoadingIndicator />;
      if (error) return `Error! ${error.message}`;

      return (
        <div>
          <HeadlineH1>Devices</HeadlineH1>
          <NewButton>
            <Link to='/new/device'>new device</Link>
          </NewButton>
          <StatusSelectionRow>
            <RefetchButton status={DEVICE_NEW} refetch={refetch} />
            <RefetchButton status={DEVICE_IN_USE} refetch={refetch} />
          </StatusSelectionRow>
          <EntityTable
            tableConfig={_tableConfig(maxRows, role)}
            totalRows={loading ? 0 : allDevices.length}
            data={loading ? [] : allDevices}
            msg={'No parts available'}
            onRowClicked={(row) => history.push('/device/' + row._id)}
          />
        </div>
      );
    }}
  </Query>
);
Devices.propTypes = {
  maxRows: PropTypes.number,
  history: PropTypes.object.isRequired,
};
Devices.defaultProps = {
  maxRows: 30,
};

export default withRouter(Devices);



// WEBPACK FOOTER //
// ./src/components/Devices.js